import removeSignatureFromBody from "./removeSignatureFromBody";

const textToSpeech = (text) => {
  if (!window.speechSynthesis) {
    return;
  }

  if (window.speechSynthesis.speaking) {
    window.speechSynthesis.cancel();
    return;
  }

  const utterance = new SpeechSynthesisUtterance(removeSignatureFromBody(text));

  utterance.lang = "pt-BR";
  utterance.pitch = 1;
  utterance.rate = 1;
  utterance.volume = 1;

  window.speechSynthesis.speak(utterance);
};

export default textToSpeech;
